<template>
  <div class="alert mb-0" :class="'alert-' + type">
    <i v-if="exclaim" class="fa fa-exclamation-circle" aria-hidden="true"></i>
    <i v-if="info" class="fa fa-info-circle" aria-hidden="true"></i>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      required: false,
      type: String,
      default: "success",
    },
    exclaim: {
      required: false,
      type: Boolean,
      default: false,
    },
    info: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
};
</script>
